import axios from "../../axios";
import {
  GET_CUSTOMER_LIST, CHANGE_CUSTOMER_STATUS, GET_A_CUSTOMER, GET_CUSTOMER_HISTORY, GET_TEMP_CUSTOMER, UPDATE_A_CUSTOMER, GET_A_GROUP_DETAIL,
  DELETE_A_CUSTOMER, BULK_DELETE_CUSTOMERS, GET_GROUP_LIST, UPDATE_A_GROUP, CREATE_A_GROUP, DELETE_A_GROUP, GET_A_DELETE_GROUP_DETAIL,
  GET_CHART_INFO, GET_CUSTOMER_LIST_NOT_IN_GROUP, UPDATE_CUSTOMER_GROUP, UPDATE_CUSTOMER_GROUP_STATUS, EXPORT_MEMBER, GET_CUSTOMER_CALLING_INFO,
  GET_SMS_TEMPLATE, SEND_SMS, CREATE_CUSTOMER, EDIT_SMS
} from "./customerListTypes";
import {
  URL_GET_CUSTOMER_LIST, URL_GET_A_CUSTOMER, URL_GET_CUSTOMER_HISTORY, URL_UPDATE_A_CUSTOMER, URL_GET_A_GROUP_DETAIL, URL_DELETE_A_CUSTOMER,
  URL_BULK_DELETE_CUSTOMERS, URL_GET_A_DELETE_GROUP_DETAIL, URL_GET_GROUP_LIST, URL_UPDATE_A_GROUP, URL_CREATE_A_GROUP, URL_DELETE_A_GROUP,
  URL_GET_CHART_INFO, URL_GET_CUSTOMER_LIST_NOT_IN_GROUP, URL_UPDATE_CUSTOMER_GROUP, URL_EXPORT_MEMBER, URL_GET_CUSTOMER_CALLING_INFO,
  URL_GET_SMS_TEMPLATE, URL_SEND_SMS, URL_CREATE_CUSTOMER, URL_EDIT_SMS
} from "./customerListUrls";
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import store from '../store'

export default {
  [GET_CUSTOMER_LIST]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CUSTOMER_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CUSTOMER_LIST, data);
              resolve(data);
            } else {
              commit(GET_CUSTOMER_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_CUSTOMER_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result == null) {
          //   commit(GET_CUSTOMER_LIST, {items: [], _links: {}, _meta: {}});
          //   resolve({items: [], _links: {}, _meta: {}})
          // } else {
          //   commit(GET_CUSTOMER_LIST, response.data.result.data);
          //   resolve(response.data.result.data)
          // }

        })
        .catch((error) => { reject(error); })
    })
  },

  [GET_CUSTOMER_LIST_NOT_IN_GROUP]({ commit }, item) {
    let param = new URLSearchParams(item).toString()
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CUSTOMER_LIST_NOT_IN_GROUP}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CUSTOMER_LIST, data);
              resolve(data);
            } else {
              commit(GET_CUSTOMER_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_CUSTOMER_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result == null) {
          //   commit(GET_CUSTOMER_LIST, {items: [], _links: {}, _meta: {}});
          //   resolve({items: [], _links: {}, _meta: {}})
          // } else {
          //   commit(GET_CUSTOMER_LIST, response.data.result.data);
          //   resolve(response.data.result.data)
          // }
        })
        .catch((error) => { reject(error); })
    })
  },

  [CHANGE_CUSTOMER_STATUS]({ commit }, item) {
    commit(CHANGE_CUSTOMER_STATUS, item);
  },

  [UPDATE_CUSTOMER_GROUP_STATUS]({ commit }) {
    commit(UPDATE_CUSTOMER_GROUP_STATUS);
  },

  [GET_A_CUSTOMER]({ commit }, item) {
    let param = new URLSearchParams(item)
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_A_CUSTOMER}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_A_CUSTOMER, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            commit(GET_A_CUSTOMER, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result.data == null) {
          //   commit(GET_A_CUSTOMER, {items:[],_link:{},_meta:{}});
          //   resolve({items:[],_link:{},_meta:{}})
          // } else {
          //   commit(GET_A_CUSTOMER, response.data.result.data);
          //   commit(GET_TEMP_CUSTOMER, JSON.parse(JSON.stringify(response.data.result.data)));
          //   resolve(response.data.result.data)
          // }
        }).catch((error) => { reject(error) })
    })
  },

  [GET_CHART_INFO]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CHART_INFO}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CHART_INFO, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            resolve({});
          }
          // if(response.data.result.data == null) {
          //   resolve({})
          // } else {
          //   commit(GET_CHART_INFO, response.data.result.data);
          //   resolve(response.data.result.data)
          // }
        }).catch((error) => { reject(error) })
    })
  },

  [GET_A_GROUP_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_A_GROUP_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_A_GROUP_DETAIL, data);
              resolve(data);
            } else {
              commit(GET_A_GROUP_DETAIL, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_A_GROUP_DETAIL, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result == null) {
          //   commit(GET_A_GROUP_DETAIL, {items:[],_link:{},_meta:{}});
          //   resolve({items:[],_link:{},_meta:{}})
          // } else {
          //   commit(GET_A_GROUP_DETAIL, response.data.result.data);
          //   resolve(response.data.result.data)
          // }
        }).catch((error) => { reject(error) })
    })
  },

  [GET_A_DELETE_GROUP_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_A_DELETE_GROUP_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_A_DELETE_GROUP_DETAIL, data);
              resolve(data);
            } else {
              commit(GET_A_DELETE_GROUP_DETAIL, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_A_DELETE_GROUP_DETAIL, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result == null) {
          //   commit(GET_A_DELETE_GROUP_DETAIL, {items:[],_link:{},_meta:{}});
          //   resolve({items:[],_link:{},_meta:{}})
          // } else {
          //   commit(GET_A_DELETE_GROUP_DETAIL, response.data.result.data);
          //   resolve(response.data.result.data)
          // }
        }).catch((error) => { reject(error) })
    })
  },

  [GET_TEMP_CUSTOMER]({ commit }, item) {
    commit(GET_TEMP_CUSTOMER, item);
  },

  [UPDATE_A_CUSTOMER]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_A_CUSTOMER}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page: item.page,
                "per-page": item["per-page"],
                search: ''
              }
              if (item.keyword) {
                temp.keyword = item.keyword;
              }
              if (item.type) {
                temp.type = item.type;
              }
              dispatch(GET_CUSTOMER_LIST, temp);
              dispatch(GET_A_CUSTOMER, item);
              let checkout_filter = {};
              if (item.checkout_filter) {
                if (item.checkout_filter.keyword != '') {
                  checkout_filter.keyword = item.checkout_filter.keyword;
                }
                if (item.checkout_filter.sort != '') {
                  checkout_filter.sort = item.checkout_filter.sort;
                }
                if (item.checkout_filter.type != '') {
                  checkout_filter.type = item.checkout_filter.type;
                }
              }
              store.dispatch('checkin/GET_CHECKIN_LIST', checkout_filter);
              if(item.isFromCalling) {
                let calling_obj = {
                  phone: item.phone
                }
                dispatch(GET_CUSTOMER_CALLING_INFO, calling_obj);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // let temp = {
          //   page: item.page,
          //   "per-page": item["per-page"],
          //   search: ''
          // }
          // dispatch('GET_CUSTOMER_LIST', temp);
          // dispatch('GET_A_CUSTOMER', item);
          // resolve(response.data.result.data);
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_CUSTOMER_HISTORY]({ commit }, item) {
    let param = new URLSearchParams(item)
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CUSTOMER_HISTORY}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CUSTOMER_HISTORY, data);
              resolve(data);
            } else {
              // reject(resultModel.message);
              commit(GET_CUSTOMER_HISTORY, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.result != null) {
          //   commit(GET_CUSTOMER_HISTORY, response.data.result.data);
          //   resolve(response.data.result.data)
          // }
        }).catch(err => reject(err))
    })
  },

  [DELETE_A_CUSTOMER]({ commit, dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_DELETE_A_CUSTOMER}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              delete item.customer_ids
              dispatch(GET_A_GROUP_DETAIL, item);
              // dispatch(GET_CUSTOMER_LIST_NOT_IN_GROUP, item);
              // dispatch(GET_A_DELETE_GROUP_DETAIL, item)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            commit(GET_CUSTOMER_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result == null) {
          //   commit(GET_CUSTOMER_LIST, {items: [], _links: {}, _meta: {}});
          //   resolve({items: [], _links: {}, _meta: {}})
          // } else {
          //   delete item.customer_ids
          //   dispatch('GET_A_GROUP_DETAIL', item);
          //   dispatch('GET_CUSTOMER_LIST_NOT_IN_GROUP',item)
          //   resolve(response.data.result.data)
          // }
        }).catch((error) => { reject(error) })
    })
  },

  [BULK_DELETE_CUSTOMERS]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_BULK_DELETE_CUSTOMERS}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_CUSTOMER_LIST, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.result.data !== null) {
          // //   commit(GET_CUSTOMER_LIST, {});
          // //   // resolve({})
          // // } else {
          //   dispatch('GET_CUSTOMER_LIST', item);
          //   resolve(response.data.result.data)
          // }
        }).catch((error) => { reject(error) })
    })
  },

  [GET_GROUP_LIST]({ commit }, item) {
    let param = new URLSearchParams({ page: item.page, 'per-page': item['per-page'] }).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_GROUP_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_GROUP_LIST, data);
              resolve(data);
            } else {
              commit(GET_GROUP_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_GROUP_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
        }).catch((error) => { reject(error) })
    })
  },

  [UPDATE_A_GROUP]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_A_GROUP}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              delete item.name
              delete item.customer_ids
              dispatch(GET_A_GROUP_DETAIL, item)
              dispatch(GET_GROUP_LIST, item);
              // dispatch(GET_A_GROUP_DETAIL, item)
              // dispatch(GET_A_DELETE_GROUP_DETAIL, item)
              // dispatch(GET_CUSTOMER_LIST_NOT_IN_GROUP, item)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // delete item.name
          // delete item.customer_ids
          // dispatch('GET_GROUP_LIST',item)
          // dispatch('GET_A_GROUP_DETAIL',item)
          // dispatch('GET_A_DELETE_GROUP_DETAIL', item)
          // dispatch('GET_CUSTOMER_LIST_NOT_IN_GROUP',item)
          // resolve(response);
        })
        .catch((error) => { reject(error) });
    })
  },

  [CREATE_A_GROUP]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CREATE_A_GROUP}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              delete item.name
              dispatch(GET_GROUP_LIST, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // delete item.name
          // dispatch('GET_GROUP_LIST',item);
          // resolve(response)
        })
        .catch((error) => { reject(error) });
    })
  },

  [DELETE_A_GROUP]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DELETE_A_GROUP}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_GROUP_LIST, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // dispatch('GET_GROUP_LIST',item);
          // resolve(response)
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [UPDATE_CUSTOMER_GROUP]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_CUSTOMER_GROUP}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                id: item.customer_id
              }
              dispatch(GET_A_CUSTOMER, temp);

              let checkout_filter = {};
              if (item.checkout_filter) {
                if (item.checkout_filter.keyword != '') {
                  checkout_filter.keyword = item.checkout_filter.keyword;
                }
                if (item.checkout_filter.sort != '') {
                  checkout_filter.sort = item.checkout_filter.sort;
                }
                if (item.checkout_filter.type != '') {
                  checkout_filter.type = item.checkout_filter.type;
                }
              }
              store.dispatch('checkin/GET_CHECKIN_LIST', checkout_filter);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [EXPORT_MEMBER]({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_MEMBER}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) })
    })
  },

  [GET_CUSTOMER_CALLING_INFO]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_CUSTOMER_CALLING_INFO, {
        params: params
      })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CUSTOMER_CALLING_INFO, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.status);
          }
        }).catch((error) => { reject(error) })
    })
  },

  [GET_SMS_TEMPLATE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_SMS_TEMPLATE, {
        params: params
      })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SMS_TEMPLATE, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.status);
          }
        }).catch((error) => { reject(error) })
    })
  },

  [SEND_SMS]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_SEND_SMS}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CREATE_CUSTOMER]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CREATE_CUSTOMER}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [EDIT_SMS]({ dispatch }, dataPost) {
    return new Promise((resolve, reject) => {
      axios.post(URL_EDIT_SMS, dataPost)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
}
